import React, { useState, useRef, useEffect, useMemo } from "react";

const MAX_LINES = 6;
const LINE_HEIGHT = 1.4;

// Detecte si un texte ne contient que des emojis (et espaces)
const EMOJI_REGEX = /^[\p{Emoji_Presentation}\p{Extended_Pictographic}\uFE0F\u200D\s]+$/u;

function isOnlyEmojis(text) {
  if (typeof text !== "string" || text.trim().length === 0) return false;
  return EMOJI_REGEX.test(text.trim());
}

export default function ExpandableText({
  children,
  maxLines = MAX_LINES,
}) {
  const [expanded, setExpanded] = useState(false);
  const [needsTruncation, setNeedsTruncation] = useState(false);
  const contentRef = useRef(null);

  const emojiOnly = useMemo(() => {
    if (typeof children === "string") return isOnlyEmojis(children);
    return false;
  }, [children]);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const lineHeightPx =
      parseFloat(getComputedStyle(el).fontSize) * LINE_HEIGHT;
    const maxHeight = lineHeightPx * maxLines;
    setNeedsTruncation(el.scrollHeight > maxHeight + 2);
  }, [children, maxLines]);

  const linkColor = "#f57c00";

  return (
    <div>
      <div
        ref={contentRef}
        style={{
          overflow: "hidden",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: expanded ? "unset" : maxLines,
          lineHeight: emojiOnly ? 1.2 : LINE_HEIGHT,
          ...(expanded
            ? {}
            : { maxHeight: `calc(${maxLines} * ${LINE_HEIGHT}em)` }),
          ...(emojiOnly ? { fontSize: "2.5rem" } : {}),
        }}
      >
        {children}
      </div>
      {needsTruncation && (
        <span
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((v) => !v);
          }}
          style={{
            color: linkColor,
            fontSize: "0.75rem",
            fontWeight: 600,
            cursor: "pointer",
            userSelect: "none",
            display: "inline-block",
            marginTop: "2px",
          }}
        >
          {expanded ? "Voir moins" : "Voir plus"}
        </span>
      )}
    </div>
  );
}
